import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'selector-card',
    imports: [CommonModule],
    templateUrl: './selector-card.component.html',
    styles: ``
})
export class SelectorCardComponent {
  @Input() sizeClass: string = ' h-[80px] min-w-[200px] ';
  @Input() active: boolean = false;
  @Input() isShowTick: boolean = true;
  @Input() tickPosition: 'top' | 'right' | 'left' = 'top';
  @Input() tickSize: 'sm' | 'md' | 'lg' = 'lg';
  @Input() checkDirection: boolean = true;
  @Input() isLtr: boolean = false;
  @Input() isReadonly: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.checkDirection && this.tickPosition != 'top') {
      if (this.isLtr) this.tickPosition = 'left';
      else this.tickPosition = 'right';
    }
  }
}
